module.exports = __webpack_public_path__ + "img/Mb_MiddleSide_Left.a2db4fe2.jpg";